import AOS from 'simple-aos'

export function aos() {
	AOS.init({
		duration: 600,
		easing: 'ease-out',
		once: true,
		offset: 80,
	})
}
